import * as React from "react";
import { useMemo, useCallback } from 'react';
import { getTimezoneAbbreviation } from "../../../shared/api/time";
import {
    ProgramClassItem,
    ProgramClassMeeting,
} from "../../interfaces/program";

interface ProgramClassScheduleProps {
    programclass: ProgramClassItem;
}
const ProgramClassSchedule = ({ programclass }: ProgramClassScheduleProps) => {
    const tzAbbrev = getTimezoneAbbreviation(programclass.timezone);
    const timeFormatter = useMemo(() => {
        return new Intl.DateTimeFormat("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
            timeZone: programclass.timezone,
        });
    }, [programclass.timezone]);

    const dayOfWeekFormatter = useMemo(() => {
        return new Intl.DateTimeFormat("en-US", {
            weekday: "long",
            timeZone: programclass.timezone,
        });
    }, [programclass.timezone]);

    const dateFormatter = useMemo(() => {
        return new Intl.DateTimeFormat("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
            timeZone: programclass.timezone,
        });
    }, [programclass.timezone]);

    const getFormattedDateRange = useCallback((
        startDate: Date,
        endDate: Date,
    ): string => {
        const startTime = timeFormatter.format(startDate);
        const endTime = timeFormatter.format(endDate);

        if (startTime === endTime) {
            return startTime;
        } else {
            return `${startTime} - ${endTime}`;
        }
    }, [timeFormatter]); // Dependency is the memoized formatter

    const meetinglist = programclass.meetings.map(
        (mtg) => {
            const startDate = new Date(mtg.scheduleDateMs);
            const endDate = new Date(mtg.scheduleEndDateMs);
            const fullDay = dayOfWeekFormatter.format(startDate);
            const fullDate = dateFormatter.format(startDate);

            return (
                <tr key={mtg.programClassMeetingId}>
                    <td className="d-none d-md-table-cell">{fullDay}</td>
                    <td>{fullDate}</td>
                    <td>
                        {getFormattedDateRange(startDate, endDate)} {tzAbbrev}
                    </td>
                    <td>{mtg.meetingName}</td>
                </tr>
            );
        },
    );

    return (
        <div className="register-schedule">
            <table className="register-schedule-table">
                <thead>
                    <tr>
                        <th className="d-none d-md-table-cell">Day</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Meeting</th>
                    </tr>
                </thead>
                <tbody>
                    {meetinglist}
                </tbody>
            </table>
        </div>
    );
};

export default React.memo(ProgramClassSchedule);
